import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Select,
  MenuItem,
  TextField,
  InputLabel,
  FormControl,
  Box,
  Typography
} from "@mui/material";

const IssueOptionsDialog = ({ 
  open,
  onClose,
  question,
  options,
  onSave
}) => {
  const [selectedOption, setSelectedOption] = useState("");
  const [customText, setCustomText] = useState("");

  useEffect(() => {
    if (open) {
      setSelectedOption("");
      setCustomText("");
    }
  }, [open]);

  const handleSubmit = () => {
    const result = selectedOption === "Other" 
      ? customText 
      : options.find(opt => opt.id === selectedOption)?.text || "";
    onSave(result);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{question}</DialogTitle>
      <DialogContent dividers>
        <Box mb={2}>
          <FormControl fullWidth variant="outlined">
            <InputLabel>Select Issue</InputLabel>
            <Select
              value={selectedOption}
              onChange={(e) => setSelectedOption(e.target.value)}
              label="Select Issue"
            >
              {options.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.text}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {selectedOption === "Other" && (
            <TextField
              fullWidth
              variant="outlined"
              margin="normal"
              label="Additional Comments"
              value={customText}
              onChange={(e) => setCustomText(e.target.value)}
            />
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button 
          onClick={handleSubmit} 
          variant="contained" 
          color="primary"
          disabled={!selectedOption || (selectedOption === "Other" && !customText)}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default IssueOptionsDialog;